import { useToast, UseToastOptions } from '@chakra-ui/react';
import { secondsToMilliseconds } from 'date-fns';
import { useCallback } from 'react';

// This module exists to standardise access to the Toast API for various use-cases
// Currently it's very rare to vary the position of toasts.

export const defaultOptions: Partial<UseToastOptions> = {
  duration: secondsToMilliseconds(5),
  position: 'top',
  isClosable: true,
};

export type Toaster = (options?: Partial<UseToastOptions>) => void;

export const useErrorToast = (): Toaster => {
  const toast = useToast();

  return useCallback(
    (options) => {
      toast({
        ...defaultOptions,
        title: 'Something went wrong.',
        status: 'error',
        duration: null,
        ...options,
      });
    },
    [toast]
  );
};

export const useSuccessToast = (): Toaster => {
  const toast = useToast();

  return useCallback(
    (options) =>
      toast({
        ...defaultOptions,
        status: 'success',
        ...options,
      }),
    [toast]
  );
};

export const useInfoToast = (): Toaster => {
  const toast = useToast();

  return useCallback(
    (options) =>
      toast({
        ...defaultOptions,
        status: 'info',
        ...options,
      }),
    [toast]
  );
};
